import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ErweiterteSucheService } from '../../../services/filter/erweiterte-suche.service';

@Component({
  selector: 'now-wbsuche-lib-erweiterte-suche-toggle',
  templateUrl: './erweiterte-suche-toggle.component.html',
  imports: []
})
export class ErweiterteSucheToggleComponent {
  private readonly erweiterteSucheService = inject(ErweiterteSucheService);

  public erweiterteSucheActive = toSignal(this.erweiterteSucheService.erweiterteSucheActive$);

  public activateWeitereFilter() {
    this.erweiterteSucheService.setAktiv(true);
  }
}
